const mapStateToProps = state => 
     ({
        menu: state.security.menu
    });

export default mapStateToProps;
